import { render, staticRenderFns } from "./initBookkeeping.vue?vue&type=template&id=ebbb3652"
import script from "./initBookkeeping.vue?vue&type=script&lang=js"
export * from "./initBookkeeping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports